import { IStudyReportWizard } from "./study-report.wizard.service";
import { StudyReportSearchItem } from "../../../model/study-report-search-item";
import { MedicalOrderOperation } from "../../../model/medical-order-operation";
import { PdfService } from "../../pdf.service";
import { SafeResourceUrl } from "@angular/platform-browser";
import { StudyReportEdit } from "../../../model/study-report-edit";
import { AuthService } from "../../auth.service";
import { MatDialog } from "@angular/material";
import { StudyReportStateEnum } from "../../../model/study-report-state";
// tslint:disable-next-line:max-line-length
import { StudyReportReverserReasonDialogComponent } from "../../../components/dialogs/study-report-reverser-reason/study-report-reverser-reason-dialog.component";
import { ReportViewer } from "../../../model/report-viewer";
import { StudyReportService } from "../../study-report/study-report.service";
import { StructuredDiagnosisColumnItem } from "src/app/model/study-report-text";
import { StudyReportTypeModalityEnum } from "src/app/model/study-report/study-report-type-modality";
import { StudyReportSections } from "src/app/model/study-report/study-report-sections";

export class StudyReporDirectTypingWordWizard implements IStudyReportWizard {
  constructor(
    studyReportSearchItem: StudyReportSearchItem,
    private pdfService: PdfService,
    private dialog: MatDialog,
    private authService: AuthService,
    private studyReportService: StudyReportService,
    public isReadOnly: boolean
  ) {
    this.editInWord = true;
    this.physicianId = Number(this.authService.getPhysicianId());
    this.studyReportSearchItem = studyReportSearchItem;
    this.patientId = studyReportSearchItem.PacientId;
    this.medicalOrderId = studyReportSearchItem.MedicalOrderId;
    this.studyReportId = studyReportSearchItem.StudyReportId;
    this.practiceName = studyReportSearchItem.PracticeName;
    this.medicalAppointmentId = studyReportSearchItem.MedicalApponitmentId;
    this.deliveryDate = studyReportSearchItem.DeliveryDate;
    this.serviceName = studyReportSearchItem.ServiceName;
    this.serviceInformaTxControl = studyReportSearchItem.ServiceInformaTxControl;
  }

  studyReportSearchItem: StudyReportSearchItem;
  medicalOrderOperation: MedicalOrderOperation;
  safeResourceUrl: SafeResourceUrl;

  editInWord: boolean;
  physicianId: number;
  deliveryDate: Date;
  medicalAppointmentId: number;
  practiceName: string;
  serviceName: string;
  patientId: number;
  medicalOrderId: number;
  studyReportId: number;
  setControlAdmin: boolean;
  serviceInformaTxControl: boolean;

  getStudyReportPdfSafeResourceUrl(): SafeResourceUrl {
    return this.safeResourceUrl;
  }

  getMedicalOrderOperation(): MedicalOrderOperation {
    if (!this.medicalOrderOperation) {
      this.medicalOrderOperation = new MedicalOrderOperation();
      this.medicalOrderOperation.MedicalApponitmentId =
        this.studyReportSearchItem.MedicalApponitmentId;
      this.medicalOrderOperation.Protocol = this.studyReportSearchItem.Protocol;
      this.medicalOrderOperation.MedicalOrderId =
        this.studyReportSearchItem.MedicalOrderId;
    }
    return this.medicalOrderOperation;
  }

  async refreshStudyReportPdf(
    studyReportEdit: StudyReportEdit
  ): Promise<SafeResourceUrl> {
    const res = await this.studyReportService.studyReportRefreshPdf(
      studyReportEdit
    );
    const pdfUrl = this.pdfService.base64ToPdfUrl(res.ReportBase64);
    this.safeResourceUrl = this.pdfService.pdfUrlToPdfSafeResourceUrl(pdfUrl);
    return this.safeResourceUrl;
  }

  async getStudyReportViewer(
    studyReportEdit: StudyReportEdit
  ): Promise<ReportViewer> {
    return await this.studyReportService.studyReportRefreshPdf(studyReportEdit);
  }

  async studyReportConfirm(
    typeModalityEnum: StudyReportTypeModalityEnum,
    studyReportEdit: StudyReportEdit,
    structuredDiagnosisColumnItems: StructuredDiagnosisColumnItem[]
  ): Promise<boolean> {
    studyReportEdit.UserId = this.authService.getUserId();
    return await this.studyReportService.studyReportDirectTypingConfirm(
      StudyReportTypeModalityEnum.Legacy,
      studyReportEdit,
      structuredDiagnosisColumnItems
    );
  }

    async getStudyReportSections(
      studyReportEdit: StudyReportEdit
    ): Promise<StudyReportSections> {
      return await this.studyReportService.getStudyReportSections(studyReportEdit);
    }


  async studyReportUpdate(studyReportEdit: StudyReportEdit): Promise<boolean> {
    studyReportEdit.UserId = this.authService.getUserId();
    return await this.studyReportService.studyReportDirectTypingUpdate(
      studyReportEdit
    );
  }

  canReverse(): boolean {
    return (
      <StudyReportStateEnum>this.studyReportSearchItem.StateId !==
      StudyReportStateEnum.Pending
    );
  }

  studyReportStateReverse(callBack: any): void {
    const dialogRef = this.dialog.open(
      StudyReportReverserReasonDialogComponent,
      {
        width: "50%",
        data: this.studyReportSearchItem.StudyReportId,
      }
    );

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result && callBack) {
        callBack();
      }
    });
  }
}
